module.exports = __webpack_public_path__ + "img/Picture24.c0a37a09.png";